import {
  FETCH_SALES_ORDER_LIST_REQUEST,
  FETCH_SALES_ORDER_LIST_SUCCESS,
  FETCH_SALES_ORDER_LIST_ERROR,
  FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_REQUEST,
  FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_SUCCESS,
  FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_ERROR,
  SAVE_TRACKING_MONITOR_REMOVAL_REQUEST,
  SAVE_TRACKING_MONITOR_REMOVAL_SUCCESS,
  SAVE_TRACKING_MONITOR_REMOVAL_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  error: null,
  isFetching: false,
  isSaving: false,
  removalReasonList: [],
  salesOrderList: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_SALES_ORDER_LIST_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case FETCH_SALES_ORDER_LIST_SUCCESS:
      return {
        ...state,
        error: null,
        isFetching: false,
        salesOrderList: action.payload,
      }
    case FETCH_SALES_ORDER_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      }
    case FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_SUCCESS:
      return {
        ...state,
        error: null,
        removalReasonList: action.payload,
      }
    case FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case SAVE_TRACKING_MONITOR_REMOVAL_REQUEST:
      return {
        ...state,
        isSaving: true,
      }
    case SAVE_TRACKING_MONITOR_REMOVAL_SUCCESS:
      return {
        ...state,
        isSaving: false,
      }
    case SAVE_TRACKING_MONITOR_REMOVAL_ERROR:
      return {
        ...state,
        error: action.payload,
        isSaving: false,
      }
    case FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST_REQUEST:
    default:
      return { ...state }
  }
}
